<template>
  <div v-if="canView" class="wg-row">
    <div class="wg-row">
      <div class="com-anm22-app-text-xxl">{{ $anm22.strLang(lang, 'Sites', 'Sedi') }}</div>
    </div>
    <div class="vertical-height-div" style="height:20px;"></div>
    <div v-if="!edit" class="wg-row">
      <div class="wg-row">
        <input
          type="button"
          class="small"
          :value="'+ ' + $anm22.strLang(lang, 'New place', 'Aggiungi indirizzo')"
          @click="addPlace()"
        >
      </div>
      <div 
          class="wg-row" 
          style="justify-content:center;margin:20px 0;"
          v-for="(place,index) in places.filter(p => p)"
          :key="'place-'+index">
        <w-g-world-place-container 
            :place="place"
            :assoc="getAssoc(place)"
            :extended="true"
            :pinToTop="true"
            :editFn="editPlace"
            :deleteFn="deletePlace"
            @pinToTop="setAsMain"
        ></w-g-world-place-container>
      </div>
    </div>
    <!-- Modifica place -->
    <div v-else class="wg-row">
      <div class="wg-row">
        <div class="com-anm22-app-text-xxl">{{ $anm22.strLang(lang, 'Edit site', 'Modifica sede') }}</div>
      </div>
      <div class="wg-row">
        <div class="vertical-height-div" style="height:10px;"></div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Name', 'Nome') }}</div>
            <div class="wg-row input-elem" style="aling-items:center;">
              <input
                class="com-anm22-app-input-text"
                style="width:200px;"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Name', 'Nome')"
                v-model="selectedPlace.name"
              >
            </div>
          </div>
        </div>
      </div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Address', 'Indirizzo') }}</div>
            <div class="wg-row input-elem" style="aling-items:center;">
              <input
                class="com-anm22-app-input-text"
                style="width:155px;"
                type="text"
                :placeholder="$anm22.strLang(lang, 'Street', 'Via')"
                v-model="selectedPlace.addressStreet"
              >
              <input
                class="com-anm22-app-input-text"
                style="width:40px;margin-left:5px;"
                type="text"
                placeholder="N."
                v-model="selectedPlace.addressNumber"
              >
            </div>
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'City', 'Città') }}</div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'City', 'Città')"
              v-model="selectedPlace.addressCity"
            >
          </div>
        </div>
      </div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'ZIP', 'CAP') }}</div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'ZIP', 'CAP')"
              v-model="selectedPlace.addressZip"
            >
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'State', 'Provincia') }}</div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'State', 'Provincia')"
              v-model="selectedPlace.addressState"
            >
          </div>
        </div>
      </div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Country', 'Paese') }}</div>
            <select class="input-elem com-anm22-app-select" v-model="selectedPlace.addressCountry">
              <option
                value
                selected
                disabled
                hidden
              >{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
              <option
                v-for="obj in Object.values($anm22.tableClasses.worldCountry().getAll()).sort((a, b) => (a[lang] < b[lang]) ? -1 : (b[lang] > b[lang]) ? 1 : 0)"
                :key="'country-'+ obj.typeClassLiteral"
                :value="obj.typeClassLiteral"
              >{{ obj[lang] }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Timezone', 'Fuso orario') }}</div>
            <select class="input-elem com-anm22-app-select" v-model="selectedPlace.timezone">
              <option
                value
                selected
                disabled
                hidden
              >{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
              <option
                v-for="(obj,key,index) in $anm22.tableClasses.worldTimezone().getAll()"
                :key="'timezone-'+index"
                :value="key"
              >{{ obj[lang] }}</option>
            </select>
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Currency', 'Valuta') }}</div>
            <select class="input-elem com-anm22-app-select" v-model="selectedPlace.currencyType">
              <option
                value
                selected
                disabled
                hidden
              >{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
              <option
                v-for="(obj,key,index) in $anm22.tableClasses.worldCurrencyType().getAll()"
                :key="'currency-'+index"
                :value="key"
              >{{ obj[lang] }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="wg-row">
        <div class="wg-col wg-xs-12 wg-sm-6">
          <div class="wg-row input-row">
            <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Daily allowance', 'Diaria') }}</div>
            <input
              class="input-elem com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Allowance', 'Diaria')"
              v-model="selectedAssoc.diary"
            >
          </div>
        </div>
      </div>
      <div class="wg-row">
        <input
          type="button"
          class="small"
          :value="$anm22.strLang(lang, 'Save', 'Salva')"
          @click="save"
        >
        <input
          type="button"
          class="small red"
          style="margin-left:10px;"
          :value="$anm22.strLang(lang, 'Cancel', 'Annulla')"
          @click="edit = false"
        >
      </div>
    </div>
    <div class="vertical-height-div" style="height:47px;"></div>
  </div>
  <div v-else class="wg-row">
    <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Permission denied.', 'Non hai i permessi per accedere a questa tab.') }}</div>
  </div>
</template>

 <script>
import _ from "lodash";
import { mapState } from "vuex";
import WGWorldPlaceContainer from "../../../../world/spa/components/WGWorldPlaceContainer.vue";

export default {
  props: {
    contactId: [String, Number],
    canView: Boolean
  },
  data() {
    return {
      edit: false,
      mode: null,
      selectedPlace: null,
      selectedAssoc: null
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    }),
    contact() {
      return this.$store.getters["contacts/get"](this.contactId);
    },
    places() {
      if(this.contact.places) {
        return this.contact.places.map(p => this.$store.getters["places/get"](p));
      } else {
        return [];
      }
    },
    assocs() {
      if(this.contact) {
        return this.$store.getters['contactPlaceAssocs/getByContact'](this.contact.idContactsContact);
      } else {
        return [];
      }
    },
    country: {
      get() {
        return selectedPlace.addressCountry ? selectedPlace.addressCountry : "";
      },
      set(newVal) {
        selectedPlace.addressCountry = newVal;
      }
    }
  },
  methods: {
    getAssoc(place) {
      return this.assocs.find(a => a.place === place.idWorldPlace);
    },
    addPlace() {
      this.selectedPlace = {};
      this.selectedAssoc = {};
      this.edit = true;
    },
    editPlace(id) {
      this.selectedPlace = this.places.find(p => p.idWorldPlace === id);
      this.selectedAssoc = this.getAssoc(this.selectedPlace);
      this.edit = true;
    },
    deletePlace(id) {
      this.$http
        .post('contact/deleteplace', {
          contactId: this.contact.idContactsContact,
          placeId: id
        }, {
          withCredentials: true
        })
        .then(response => {
          Promise.all([
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact]
            }),
            this.$store.dispatch("places/delete", {
              vlf: this.$vlf("places"),
              obj: place
            })
          ]);
        })
        .catch(e => {
          // No offline yet
        });
    },
    save() {
      this.$http
        .post("contact/saveplace", {
          contactId: this.contact.idContactsContact,
          place: this.selectedPlace,
          assoc: this.selectedAssoc
        }, {
          withCredentials: true
        })
        .then(response => {
          Promise.all([
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact]
            }),
            this.$store.dispatch("places/update", {
              vlf: this.$vlf("places"),
              objs: [response.data.place]
            }),
            this.$store.dispatch("contactPlaceAssocs/update", {
              vlf: this.$vlf("contactPlaceAssocs"),
              objs: [response.data.assoc]
            })
          ]);
        })
        .catch(error => {
          /* No offline yet */
        })
        .finally(() => {
          this.selectedPlace = null;
          this.edit = false;
        });
    },
    setAsMain(placeId) {
      //usare this.selectedPlace
      this.$http
        .post("contact/setplaceasmain", {
          contactId: this.contact.idContactsContact,
          placeId: placeId
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store.dispatch('contactPlaceAssocs/update', {
            vlf: this.$vlf('contactPlaceAssocs'), objs: response.data.contactPlaceAssocs
          });
        })
        .catch(e => console.log(e));
    }
  },
  components: {
    WGWorldPlaceContainer
  }
};
</script>
 
<style lang="scss" scoped>
.input-elem {
  max-width: 200px;
}
.input-row {
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
  margin-bottom: 10px;
}
</style>
 
